module.exports = "/_next/static/images/b860f80f7ff43f9e18e2153a66acc087-rewards-app-md@3x.png.webp";